(function () {
  'use strict';

  var root = document.querySelector('[data-fyf-root]');
  if (!root) return;

  var submitEndpoint = root.getAttribute('data-submit-endpoint') || '';
  var maxColors = parseInt(root.getAttribute('data-max-colors'), 10) || 3;

  var current = 0;
  var answers = { style: null, colors: [], photo: null, photos: [], method: null };
  var TOTAL_STEPS = 5;
  var STEP_OF = { 1: 1, 2: 2, 3: 3, 4: 4, 5: 5 };

  var stage   = document.getElementById('fyf-stage');
  var pageBg  = document.querySelector('.fyf-page-bg');
  var barFill = document.getElementById('fyf-bar-fill');

  function setBar(n) { barFill.style.width = (STEP_OF[n] ? (STEP_OF[n] / TOTAL_STEPS) * 100 : (n >= 6 ? 100 : 0)) + '%'; }

  // Intentional: on mobile the style (1), colour (2) + contact (5) steps sit a
  // touch high of dead-centre so their content doesn't read as floating low on
  // the screen. Other steps stay centred. Tweak MOBILE_LIFT to taste.
  var MOBILE_LIFT = 48;
  function screenLift(n) {
    if ((n === 1 || n === 2 || n === 5) && window.matchMedia('(max-width:640px)').matches) return MOBILE_LIFT;
    return 0;
  }
  function centeredMarginTop(h, n) {
    var cs = getComputedStyle(pageBg);
    var padTop = parseFloat(cs.paddingTop) || 0;
    var padBottom = parseFloat(cs.paddingBottom) || 0;
    var avail = pageBg.clientHeight - padTop - padBottom;
    return Math.max(0, (avail - h) / 2 - screenLift(n));
  }
  function resnapCenter() {
    if (stage.classList.contains('is-resizing')) return;
    stage.style.marginTop = centeredMarginTop(stage.offsetHeight, current) + 'px';
  }
  resnapCenter();
  window.addEventListener('resize', resnapCenter);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(resnapCenter);

  /* The global header auto-hides when you scroll to the page bottom (adds
     .is-hidden-bottom). The sticky progress bar is pinned to top:var(--nav-h),
     so when the header tucks away the bar would be left hanging over the wizard
     content. Mirror the header's hidden state onto the bar so they move as one. */
  (function () {
    var headerEl = document.querySelector('.header');
    var barEl = root.querySelector('.fyf-bar');
    if (!headerEl || !barEl) return;
    var syncBar = function () {
      barEl.classList.toggle('is-hidden', headerEl.classList.contains('is-hidden-bottom'));
    };
    syncBar();
    new MutationObserver(syncBar).observe(headerEl, { attributes: true, attributeFilter: ['class'] });
  })();

  function goTo(n, isBack) {
    var prev = document.getElementById('fyf-' + current);
    var next = document.getElementById('fyf-' + n);
    var wasCam = (current === 4);

    var startH = stage.offsetHeight;
    var startMT = centeredMarginTop(startH, current);
    stage.style.height = startH + 'px';
    stage.style.marginTop = startMT + 'px';
    void stage.offsetHeight;

    // Same cross-fade in both directions; isBack no longer changes the visual.
    // The 380ms cleanup matches --fyf-dur in section-find-your-fit.css.
    if (prev) {
      prev.classList.add('is-leaving'); prev.classList.remove('is-active');
      setTimeout(function () { prev.classList.remove('is-leaving'); }, 380);
    }
    if (next) {
      next.classList.add('is-active');
    }
    current = n; setBar(n);

    var targetH = next ? next.offsetHeight : startH;
    var targetMT = centeredMarginTop(targetH, n);
    stage.classList.add('is-resizing'); void stage.offsetHeight;
    stage.style.height = targetH + 'px';
    stage.style.marginTop = targetMT + 'px';
    clearTimeout(stage._ht);
    if (stage._hth) stage.removeEventListener('transitionend', stage._hth);
    stage._hth = function (e) {
      if (e.target !== stage || e.propertyName !== 'height') return;
      stage.removeEventListener('transitionend', stage._hth); stage._hth = null;
      clearTimeout(stage._ht); stage.classList.remove('is-resizing');
      stage.style.height = '';
      resnapCenter();
    };
    stage.addEventListener('transitionend', stage._hth);
    stage._ht = setTimeout(function () {
      if (stage._hth) { stage.removeEventListener('transitionend', stage._hth); stage._hth = null; }
      stage.classList.remove('is-resizing');
      stage.style.height = '';
      resnapCenter();
    }, 440); // safety net if `height` transitionend never fires; just over --fyf-dur (380ms)

    if (wasCam && n !== 4) stopCameraSmooth();
    if (n === 4) {
      if (answers.method === 'upload' && answers.photo) startUploadFlow();
      else startScan();
    }
  }

  document.querySelectorAll('.fyf-back').forEach(function (b) {
    b.addEventListener('click', function () { goTo(parseInt(b.dataset.back, 10), true); });
  });
  document.getElementById('fyf-start-btn').addEventListener('click', function () { goTo(1, false); });

  /* style — single select, auto-advance */
  document.querySelectorAll('#fyf-styles .fyf-scard').forEach(function (c) {
    c.addEventListener('click', function () {
      document.querySelectorAll('#fyf-styles .fyf-scard').forEach(function (x) { x.classList.remove('is-selected'); });
      c.classList.add('is-selected'); answers.style = c.dataset.style;
      setTimeout(function () { goTo(2, false); }, 320);
    });
  });

  /* colours — multi, up to maxColors */
  var swatches = document.querySelectorAll('#fyf-swatches .fyf-swatch');
  var pickCount = document.getElementById('fyf-pickcount');
  var step2Btn = document.getElementById('fyf-step2-btn');
  function refreshColors() {
    var n = answers.colors.length;
    pickCount.textContent = n + ' / ' + maxColors + ' selected';
    step2Btn.disabled = n === 0;
    swatches.forEach(function (s) { s.classList.toggle('is-disabled', !s.classList.contains('is-selected') && n >= maxColors); });
  }
  swatches.forEach(function (s) {
    s.addEventListener('click', function () {
      var col = s.dataset.color, i = answers.colors.indexOf(col);
      if (i > -1) { answers.colors.splice(i, 1); s.classList.remove('is-selected'); }
      else if (answers.colors.length < maxColors) { answers.colors.push(col); s.classList.add('is-selected'); }
      refreshColors();
    });
  });
  step2Btn.addEventListener('click', function () { goTo(3, false); });

  /* scan intro */
  document.getElementById('fyf-ai-btn').addEventListener('click', function () { answers.method = 'camera'; goTo(4, false); });
  var fileInput = document.getElementById('fyf-file');
  document.getElementById('fyf-upload-btn').addEventListener('click', function () { fileInput.click(); });
  document.getElementById('fyf-cam-upload-link').addEventListener('click', function () { fileInput.click(); });
  document.getElementById('fyf-error-upload').addEventListener('click', function () { fileInput.click(); });
  fileInput.addEventListener('change', function () {
    var f = fileInput.files && fileInput.files[0]; if (!f) return;
    var reader = new FileReader();
    reader.onload = function () {
      answers.method = 'upload'; answers.photo = reader.result;
      if (current === 4) {
        // Uploading via the camera screen's "upload instead" links: the live
        // camera is running (portaled on mobile), so hand off through
        // startUploadFlow() which tears it down cleanly on the way to the form.
        startUploadFlow();
      } else {
        // Uploading from the scan-intro screen: skip the camera screen entirely
        // and go straight to the form. Routing through screen 4 here mounted the
        // camera UI mid cross-fade, flashing it for a frame before the handoff.
        answers.photos = [answers.photo];
        goTo(5, false);
        showAttachment();
      }
    };
    reader.readAsDataURL(f);
    fileInput.value = ''; // allow re-selecting the same file after a back-and-forth
  });
  document.getElementById('fyf-cam-close').addEventListener('click', function () { goTo(3, true); });

  /* ── CAMERA — manual multi-angle capture ── */
  var video    = document.getElementById('fyf-video');
  var canvas   = document.getElementById('fyf-canvas');
  var ctx      = canvas.getContext('2d');
  var viewport = document.getElementById('fyf-cam-viewport');
  var ovalEl   = document.getElementById('fyf-oval');
  var topEl    = document.getElementById('fyf-cam-top');
  var loadEl   = document.getElementById('fyf-cam-loading');
  var loadTxt  = document.getElementById('fyf-loading-text');
  var errEl    = document.getElementById('fyf-cam-error');
  var errTxt   = document.getElementById('fyf-error-text');
  var closeEl  = document.getElementById('fyf-cam-close');
  var thumbsEl = document.getElementById('fyf-cam-thumbs');
  var shutterEl = document.getElementById('fyf-cam-shutter');
  var submitEl  = document.getElementById('fyf-cam-submit');

  var mediaStream = null, captured = false;
  var camWrap = viewport.parentNode;
  var portaled = false;

  var STEPS = [
    { key: 'straight', prompt: 'look straight at the camera' },
    { key: 'left',     prompt: 'now turn slightly to your left' },
    { key: 'right',    prompt: 'now turn slightly to your right' }
  ];
  var shots = [];
  var stepIndex = 0;      // next angle to capture in the guided sequence
  var retakeIndex = null; // when set, we're re-capturing just this one angle in place

  function portalIn() {
    if (portaled) return;
    if (window.matchMedia('(max-width:640px)').matches) {
      document.body.appendChild(viewport);
      viewport.classList.add('is-portal');
      document.documentElement.style.overflow = 'hidden';
      portaled = true;
    }
  }
  function portalOut() {
    if (!portaled) return;
    viewport.classList.remove('is-portal');
    camWrap.appendChild(viewport);
    document.documentElement.style.overflow = '';
    portaled = false;
  }

  function showState(which) {
    loadEl.classList.toggle('is-on', which === 'loading');
    errEl.classList.toggle('is-on', which === 'error');
    var live = (which === 'live');
    topEl.style.opacity = live ? '1' : '0';
    ovalEl.style.opacity = live ? '1' : '0';
    thumbsEl.style.opacity = live ? '1' : '0';
    closeEl.style.display = (which === 'idle') ? 'none' : 'flex';
  }

  function resetShots() {
    shots = []; stepIndex = 0; retakeIndex = null;
    thumbsEl.innerHTML = '';
  }

  function allCaptured() {
    if (shots.length < STEPS.length) return false;
    for (var i = 0; i < STEPS.length; i++) { if (!shots[i]) return false; }
    return true;
  }

  function updateStepUI() {
    // Retaking a single earlier angle: capture into that slot and keep the rest.
    if (retakeIndex !== null) {
      topEl.textContent = 'retake photo ' + (retakeIndex + 1) + ' — ' + STEPS[retakeIndex].prompt;
      topEl.classList.remove('is-good');
      ovalEl.classList.remove('is-good');
      shutterEl.style.display = '';
      submitEl.style.display = 'none';
      return;
    }
    var done = stepIndex >= STEPS.length;
    topEl.textContent = done ? 'all set — review & continue' : (stepIndex + 1) + ' of ' + STEPS.length + ' — ' + STEPS[stepIndex].prompt;
    topEl.classList.toggle('is-good', done);
    ovalEl.classList.toggle('is-good', done);
    shutterEl.style.display = done ? 'none' : '';
    submitEl.style.display = done ? '' : 'none';
  }

  // One thumbnail per angle, kept in a stable slot (data-thumb) so a retake
  // updates that photo in place instead of wiping the ones around it.
  function setThumb(index, dataUrl) {
    var t = thumbsEl.querySelector('[data-thumb="' + index + '"]');
    if (!t) {
      t = document.createElement('div');
      t.className = 'fyf-cam-thumb';
      t.setAttribute('data-thumb', index);
      var img = document.createElement('img'); img.alt = STEPS[index].key + ' photo';
      t.appendChild(img);
      var badge = document.createElement('span');
      badge.className = 'fyf-cam-thumb__n'; badge.textContent = index + 1;
      t.appendChild(badge);
      t.addEventListener('click', function () { retakeOne(index); });
      thumbsEl.appendChild(t);
    }
    t.querySelector('img').src = dataUrl;
  }

  function highlightRetake() {
    Array.prototype.forEach.call(thumbsEl.children, function (el) {
      el.classList.toggle('is-retaking', retakeIndex !== null && el.getAttribute('data-thumb') === String(retakeIndex));
    });
  }

  function retakeOne(index) {
    if (captured) return;
    retakeIndex = index;
    highlightRetake();
    updateStepUI();
  }

  function captureShot() {
    if (captured) return;
    var idx = retakeIndex !== null ? retakeIndex : stepIndex;
    if (idx >= STEPS.length) return;
    canvas.width = video.videoWidth || 640; canvas.height = video.videoHeight || 853;
    ctx.save(); ctx.translate(canvas.width, 0); ctx.scale(-1, 1);
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height); ctx.restore();
    var dataUrl = canvas.toDataURL('image/jpeg', 0.85);
    shots[idx] = { key: STEPS[idx].key, dataUrl: dataUrl };
    setThumb(idx, dataUrl);
    if (retakeIndex !== null) { retakeIndex = null; highlightRetake(); }
    else { stepIndex++; }
    updateStepUI();
  }
  shutterEl.addEventListener('click', captureShot);
  submitEl.addEventListener('click', finalizeCapture);

  function startScan() {
    portalIn();
    viewport.classList.remove('is-portal-fading'); // clear a fade left mid-teardown on quick re-entry
    captured = false; resetShots(); updateStepUI();
    video.style.display = ''; var old = viewport.querySelector('.fyf-cam-shot'); if (old) old.remove();
    showState('loading'); loadTxt.textContent = 'starting camera…';

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { camFail('your browser does not support camera access.<br>please upload a photo instead.'); return; }
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 853 } }, audio: false })
      .then(function (stream) { mediaStream = stream; video.srcObject = stream; return video.play().catch(function () {}); })
      .then(function () { if (current !== 4 || captured) return; showState('live'); updateStepUI(); })
      .catch(function () { camFail('camera access was blocked.<br>please allow it, or upload a photo instead.'); });
  }
  function camFail(msg) { errTxt.innerHTML = msg; showState('error'); stopStreamOnly(); }

  function finalizeCapture() {
    if (captured || !allCaptured()) return;
    captured = true;
    var taken = shots.slice(0, STEPS.length);
    answers.photo = taken[0].dataUrl;
    answers.photos = taken.map(function (s) { return s.dataUrl; });
    // Don't cut the stream here — goTo()'s smooth teardown fades the fullscreen
    // overlay out (keeping the live frame) and stops it once it's invisible, so
    // the handoff to the form is a clean cross-fade rather than a black flash.
    goTo(5, false);
    showAttachment();
  }

  function startUploadFlow() {
    portalIn(); stopStreamOnly();
    captured = true; showState('idle');
    answers.photos = [answers.photo];
    goTo(5, false);
    showAttachment();
  }

  function showAttachment() {
    var photos = answers.photos && answers.photos.length ? answers.photos : (answers.photo ? [answers.photo] : []);
    if (!photos.length) return;
    var shotsEl = document.getElementById('fyf-attach-shots');
    shotsEl.innerHTML = '';
    photos.forEach(function (src) {
      var img = document.createElement('img'); img.src = src; img.alt = 'your photo'; shotsEl.appendChild(img);
    });
    document.getElementById('fyf-attach').style.display = 'flex';
  }

  function stopStreamOnly() {
    if (mediaStream) { mediaStream.getTracks().forEach(function (t) { t.stop(); }); mediaStream = null; }
    try { video.pause(); } catch (e) {} video.srcObject = null;
  }
  function stopCamera() { stopStreamOnly(); showState('idle'); portalOut(); }

  // Smooth teardown when navigating AWAY from the camera step. With the camera
  // running fullscreen (portaled to <body> on mobile), tearing it down instantly
  // makes the video flick to black as the stream is cut and flashes the small
  // in-flow viewport in the outgoing screen. Instead fade the fullscreen overlay
  // out — the incoming screen is already cross-fading in beneath it — then cut
  // the stream and move the viewport back once it's fully invisible (and the
  // outgoing screen is already display:none). Falls back to instant teardown
  // when not portaled (desktop), where the screen's own cross-fade suffices.
  function stopCameraSmooth() {
    // Only the live-camera path needs the fade. The upload path also passes
    // through here while portaled, but its portalIn→teardown is synchronous and
    // paints no overlay — instant teardown keeps it that way (no black fade).
    if (!portaled || answers.method !== 'camera') { stopCamera(); return; }
    var done = false;
    var finish = function (e) {
      if (e && (e.target !== viewport || e.propertyName !== 'opacity')) return;
      if (done) return; done = true;
      viewport.removeEventListener('transitionend', finish);
      clearTimeout(fallback);
      stopStreamOnly(); showState('idle'); portalOut();
      viewport.classList.remove('is-portal-fading');
    };
    viewport.addEventListener('transitionend', finish);
    var fallback = setTimeout(finish, 480); // just past the .4s opacity fade
    requestAnimationFrame(function () { viewport.classList.add('is-portal-fading'); });
  }
  window.addEventListener('pagehide', stopCamera);
  document.addEventListener('visibilitychange', function () { if (document.hidden && current === 4) stopCamera(); });

  /* contact + submission */
  var nameInput = document.getElementById('fyf-name'),
      emailInput = document.getElementById('fyf-email'),
      phoneInput = document.getElementById('fyf-phone');

  function submitAnswers() {
    if (!submitEndpoint) return;
    var payload = {
      style: answers.style,
      colors: answers.colors,
      method: answers.method,
      photos: answers.photos && answers.photos.length ? answers.photos : (answers.photo ? [answers.photo] : []),
      name: nameInput.value.trim(),
      email: emailInput.value.trim(),
      phone: phoneInput.value.trim()
    };
    try {
      fetch(submitEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(function () {});
    } catch (e) {}
  }

  document.getElementById('fyf-submit-btn').addEventListener('click', function () {
    var name = nameInput.value.trim(), email = emailInput.value.trim();
    if (!name || !email) {
      if (!name) nameInput.style.borderColor = 'rgba(200,40,40,.55)';
      if (!email) emailInput.style.borderColor = 'rgba(200,40,40,.55)';
      return;
    }
    submitAnswers();
    document.getElementById('fyf-confirm-name').textContent = 'thank you, ' + name + '.';
    goTo(6, false);
  });
  [nameInput, emailInput, phoneInput].forEach(function (inp) { inp.addEventListener('input', function () { inp.style.borderColor = ''; }); });
}());
